<script>
    import {toggleFavorite} from "../core/app-store.js";
    import { t } from '../core/i18n/language-store';

    export let record;
    export let open = false;

    function toggleFavoriteHandler() {
        toggleFavorite({detail: {recordId: record.id, isFavorite: !record.isFavorite}});
    }
</script>
<style>

.nutritional {
    height: 0;
    overflow: hidden;
    opacity: 0;
    transition: height .3s ease, opacity .3s ease;
}
.nutritional--open {
    height: 3.5rem;
    opacity: 1;
    border-bottom: 1px solid rgba(255,255,255, .2);
}

.nutritional ul {
    display: flex;
    gap: 16px;
    align-items: center;
    height: 100%;
    color: var(--secondary-font-color);
}
.nutritional ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.nutritional .fav-icon,
.nutritional .nut-val {
    font-family: PT Mono, sans-serif;
    font-size: 16px;
    font-weight: 600;
}
.nutritional .fav-label,
.nutritional .nut-label {
    font-family: Roboto Condensed, sans-serif;
    font-size: 12px;
    text-transform: uppercase;
}

.favorite {
    color: var(--secondary-font-color);
    transition: color .2s ease;
}
.favorite--active {
    color: var(--main-font-color);
}
.favorite--active svg {
    color: var(--accent-color);
}
</style>

<!-- NUTRITIONAL VALUE -->
<!--{#if record.nutritionalValue }-->
    <div class="nutritional" class:nutritional--open={open}>

        <ul>
            {#if record.nutritionalValue?.calories}
                <li>
                    <span class="nut-val">{record.nutritionalValue.calories}</span>
                    <span class="nut-label">{$t('nutrition.calories')}</span>
                </li>
            {/if}
            {#if record.nutritionalValue?.proteins}
                <li>
                    <span class="nut-val">{record.nutritionalValue.proteins}</span>
                    <span class="nut-label">{$t('nutrition.proteins')}</span>
                </li>
            {/if}
            {#if record.nutritionalValue?.fats}
                <li>
                    <span class="nut-val">{record.nutritionalValue.fats}</span>
                    <span class="nut-label">{$t('nutrition.fats')}</span>
                </li>
            {/if}
            {#if record.nutritionalValue?.carbohydrates}
                <li>
                    <span class="nut-val">{record.nutritionalValue.carbohydrates || '-'}</span>
                    <span class="nut-label">{$t('nutrition.carbs')}</span>
                </li>
            {/if}

            <li style="flex: 1 1"></li>

            <li class="favorite"
                class:favorite--active={record.isFavorite}
                on:click={toggleFavoriteHandler}>
                <span class="fav-icon">
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.52269 9.01053L8.02715 14.1809C8.21715 14.359 8.31215 14.4485 8.42298 14.4707C8.47343 14.4806 8.52533 14.4806 8.57578 14.4707C8.68819 14.4485 8.7824 14.3598 8.97161 14.1809L14.4761 9.01132C15.2237 8.30934 15.6826 7.3537 15.763 6.33131C15.8434 5.30891 15.5394 4.2933 14.9107 3.48311L14.6653 3.16724C13.1073 1.15957 9.98019 1.49603 8.88532 3.79028C8.85049 3.86298 8.79581 3.92436 8.72759 3.96732C8.65937 4.01028 8.58039 4.03308 8.49978 4.03308C8.41916 4.03308 8.34018 4.01028 8.27196 3.96732C8.20374 3.92436 8.14906 3.86298 8.11423 3.79028C7.01936 1.49603 3.89228 1.15878 2.33428 3.16724L2.08886 3.4839C1.46056 4.29398 1.15692 5.30925 1.2373 6.33127C1.31767 7.3533 1.77628 8.30862 2.52348 9.01053H2.52269Z" stroke="currentColor" stroke-width="2"/>
                    </svg>
                </span>
                <span class="fav-label">
                    {#if (!record.isFavorite)}
                        <span>{$t('nutrition.addToFavorites')}</span>
                    {:else}
                        <span>{$t('nutrition.inFavorites')}</span>
                    {/if}
                </span>
            </li>
        </ul>

    </div>
<!--{/if}-->
